// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add this to your CSS file for single-line alignment */
.search-controls-inline {
    display: flex;
    gap: 15px; /* Adjust spacing between fields */
    align-items: center; /* Vertically align items */
    margin-bottom: 20px;
}
.search-icon-CompOff , .ReportCompOff{
    width: 111px!important;
}
.request_heading{
    font-size: 22px;
    padding-bottom: 10px;
    font-weight: bold;
}

/* --- CompOff List Layout and Scrolling --- */

/* 1. Set up the main container to use Flexbox */
.compoff-main-container {
    /* Use a minimum height (e.g., 80% of viewport) or define height to 
       allow the table wrapper to grow and push the footer down. */
    min-height: 80vh; 
    display: flex;
    flex-direction: column; /* Stack children vertically */
    padding: 20px; /* Add internal padding */
}

/* 2. Configure the table wrapper for height and scrolling */
.compoff-table-wrapper {
  max-height: 57vh;          /* Controls vertical height */
  overflow-y: auto;          /* Vertical scrollbar */
  overflow-x: auto;          /* Horizontal scrollbar */
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

/* 3. Optional: Make the table header sticky (highly recommended for usability) */
.compoff-table-wrapper table {
    width: 100%;
    border-collapse: collapse;
}

.compoff-table-wrapper thead {
    /* Keeps the header visible when the user scrolls the table body */
    position: sticky; 
    top: 0; /* Pins it to the top of the scrollable container */
    background-color: #e9e9e9; /* Light background to hide content scrolling underneath */
    z-index: 10;
}
.apply_compOff_noReq{
    width: 100%;
    text-align: center;
    margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/AdminPanel/ReportsComponent/ViewCompOff.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;IACI,aAAa;IACb,SAAS,EAAE,kCAAkC;IAC7C,mBAAmB,EAAE,2BAA2B;IAChD,mBAAmB;AACvB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA,8CAA8C;;AAE9C,gDAAgD;AAChD;IACI;kEAC8D;IAC9D,gBAAgB;IAChB,aAAa;IACb,sBAAsB,EAAE,8BAA8B;IACtD,aAAa,EAAE,yBAAyB;AAC5C;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB,WAAW,6BAA6B;EACxD,gBAAgB,WAAW,uBAAuB;EAClD,gBAAgB,WAAW,yBAAyB;EACpD,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,iFAAiF;AACjF;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kEAAkE;IAClE,gBAAgB;IAChB,MAAM,EAAE,mDAAmD;IAC3D,yBAAyB,EAAE,0DAA0D;IACrF,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":["/* Add this to your CSS file for single-line alignment */\n.search-controls-inline {\n    display: flex;\n    gap: 15px; /* Adjust spacing between fields */\n    align-items: center; /* Vertically align items */\n    margin-bottom: 20px;\n}\n.search-icon-CompOff , .ReportCompOff{\n    width: 111px!important;\n}\n.request_heading{\n    font-size: 22px;\n    padding-bottom: 10px;\n    font-weight: bold;\n}\n\n/* --- CompOff List Layout and Scrolling --- */\n\n/* 1. Set up the main container to use Flexbox */\n.compoff-main-container {\n    /* Use a minimum height (e.g., 80% of viewport) or define height to \n       allow the table wrapper to grow and push the footer down. */\n    min-height: 80vh; \n    display: flex;\n    flex-direction: column; /* Stack children vertically */\n    padding: 20px; /* Add internal padding */\n}\n\n/* 2. Configure the table wrapper for height and scrolling */\n.compoff-table-wrapper {\n  max-height: 57vh;          /* Controls vertical height */\n  overflow-y: auto;          /* Vertical scrollbar */\n  overflow-x: auto;          /* Horizontal scrollbar */\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n}\n\n/* 3. Optional: Make the table header sticky (highly recommended for usability) */\n.compoff-table-wrapper table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.compoff-table-wrapper thead {\n    /* Keeps the header visible when the user scrolls the table body */\n    position: sticky; \n    top: 0; /* Pins it to the top of the scrollable container */\n    background-color: #e9e9e9; /* Light background to hide content scrolling underneath */\n    z-index: 10;\n}\n.apply_compOff_noReq{\n    width: 100%;\n    text-align: center;\n    margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
